import "./App.css"
import Container from "./components/container"

function App() {
  return (
    <div className="App">
      <br />
      <Container />
    </div>
  )
}

export default App
